import React, { useMemo } from 'react';

import { ChartContainer, PieChart } from '@/components/organisms/Aggregates';
import { CmCard, CmHeading } from '@/components/uiParts/';
import { PieDatum } from '@/domain/models/Chart';
import { SalesItem } from '@/domain/models/SalesReport';

interface Props {
  items: SalesItem[];
}

export const CountRatioByItem: React.FC<Props> = ({ items }) => {
  const displayData: PieDatum[] = useMemo(() => {
    const orderCountData = items.map((item) => ({
      id: item.item_name,
      value: item.order_count,
    }));
    return orderCountData;
  }, [items]);

  return (
    <CmCard>
      <CmHeading as="h2">商品ごと注文数</CmHeading>
      <ChartContainer mt={5} height="250px" width="auto">
        {displayData.length > 0 && (
          <PieChart data={displayData} format="number" />
        )}
      </ChartContainer>
    </CmCard>
  );
};
